import axios from 'axios';
import tools from './tools';

async function listProfiles(queryParams, filters, cancelTokenParam ) {  
  queryParams = queryParams || {}; 
  const cancelToken = cancelTokenParam || axios.CancelToken.source();
  
  const fields = queryParams.fields || "id";
  const expand = queryParams.expand;
  const ordering = queryParams.ordering || "first_name";
  const limit = queryParams.limit || process.env.REACT_APP_DEFAULT_LIMIT_PAGINATION; //'no_paginate';
  const offset = queryParams.offset || 0; 

  var url = `${tools.getBaseHost()}/universities/${tools.getUserData().university}/profiles/`;

  const request = axios.get(url, {
    headers: { 
      Authorization: `Bearer ${tools.getUserData().token}`,
      Timezone: tools.getTimezone()
    },
    params: {
      fields,
      expand,
      ordering,
      limit,
      offset,
      ...filters,
    },
    cancelToken: cancelToken.token 
  });

  request.catch(error => {
    tools.checkResponseStatus(error);
  });
  return request;
}

async function createUser(bodyData, cancelTokenParam ) {
  bodyData = bodyData || {}; 
  const cancelToken = cancelTokenParam || axios.CancelToken.source();

  var url = `${tools.getBaseHost()}/universities/${tools.getUserData().university}/profiles/`;  
  const request = axios.post(url, bodyData, {
    headers: { 
      Authorization: `Bearer ${tools.getUserData().token}`,
      Timezone: tools.getTimezone()
    },
    cancelToken: cancelToken.token 
  });
  request.catch(error => {
    tools.checkResponseStatus(error);
  });
  return request;
}

async function updateUser(bodyData, cancelTokenParam ) {
  bodyData = bodyData || {}; 
  const cancelToken = cancelTokenParam || axios.CancelToken.source();

  var url = `${tools.getBaseHost()}/universities/${tools.getUserData().university}/profiles/${bodyData.id}/`;  
  const request = axios.put(url, bodyData, {
    headers: { 
      Authorization: `Bearer ${tools.getUserData().token}`,
      Timezone: tools.getTimezone()
    },
    cancelToken: cancelToken.token 
  });
  request.catch(error => {
    tools.checkResponseStatus(error);
  });
  return request;
}

async function deleteUser(userId, profile, cancelTokenParam ) {    
  const cancelToken = cancelTokenParam || axios.CancelToken.source();
  var url = `${tools.getBaseHost()}/universities/${tools.getUserData().university}/profiles/${profile}/${userId}/`;  
  const request = axios.delete(url, {
    headers: { 
      Authorization: `Bearer ${tools.getUserData().token}`,
      Timezone: tools.getTimezone()
    },
    cancelToken: cancelToken.token 
  });
  request.catch(error => {
    tools.checkResponseStatus(error);
  });
  return request;
}


async function listStudentsFromCourseId(courseId, queryParams, filters, cancelTokenParam ) {
  queryParams = queryParams || {}; 
  const cancelToken = cancelTokenParam || axios.CancelToken.source();
  
  const fields = queryParams.fields || "id";
  const expand = queryParams.expand;
  const ordering = queryParams.ordering || "first_name";
  const limit = queryParams.limit || process.env.REACT_APP_DEFAULT_LIMIT_PAGINATION; 
  const offset = queryParams.offset || 0; 

  var url = `${tools.getBaseHost()}/universities/${tools.getUserData().university}/courses/${courseId}/profiles/`;

  const request = axios.get(url, {
    headers: { 
      Authorization: `Bearer ${tools.getUserData().token}`,
      Timezone: tools.getTimezone()
    },
    params: {
      fields,
      expand,
      ordering,
      limit,
      offset,
      'profile': 'student',      
      ...filters,
    },
    cancelToken: cancelToken.token 
  });

  request.catch(error => {
    tools.checkResponseStatus(error);
  });
  return request;
}


async function listStudentsExcludingCourseId(courseId, queryParams, filters, cancelTokenParam ) {
  queryParams = queryParams || {}; 
  const cancelToken = cancelTokenParam || axios.CancelToken.source();
  
  const fields = queryParams.fields || "id";
  const expand = queryParams.expand;
  const ordering = queryParams.ordering || "first_name";
  const limit = queryParams.limit || process.env.REACT_APP_DEFAULT_LIMIT_PAGINATION; 
  const offset = queryParams.offset || 0; 

  var url = `${tools.getBaseHost()}/universities/${tools.getUserData().university}/profiles/`;

  const request = axios.get(url, {
    headers: { 
      Authorization: `Bearer ${tools.getUserData().token}`,
      Timezone: tools.getTimezone()
    },
    params: {
      fields,
      expand,
      ordering,
      limit,
      offset,
      'profile': 'student',      
      'exclude_course': courseId,
      ...filters,
    },
    cancelToken: cancelToken.token 
  });

  request.catch(error => {
    tools.checkResponseStatus(error);
  });
  return request;
}

async function listTeachersFromCourseId(courseId, queryParams, filters, cancelTokenParam ) {
  queryParams = queryParams || {}; 
  const cancelToken = cancelTokenParam || axios.CancelToken.source();
  
  const fields = queryParams.fields || "id";
  const expand = queryParams.expand;
  const ordering = queryParams.ordering || "first_name";
  const limit = queryParams.limit || process.env.REACT_APP_DEFAULT_LIMIT_PAGINATION; 
  const offset = queryParams.offset || 0; 

  var url = `${tools.getBaseHost()}/universities/${tools.getUserData().university}/courses/${courseId}/profiles/`;

  const request = axios.get(url, {
    headers: { 
      Authorization: `Bearer ${tools.getUserData().token}`,
      Timezone: tools.getTimezone()
    },
    params: {
      fields,
      expand,
      ordering,
      limit,
      offset,
      'profile': 'teacher',
      ...filters,
    },
    cancelToken: cancelToken.token 
  });

  request.catch(error => {
    tools.checkResponseStatus(error);
  });
  return request;
}

async function listTeachersExcludingCourseId(courseId, queryParams, filters, cancelTokenParam ) {
  queryParams = queryParams || {}; 
  const cancelToken = cancelTokenParam || axios.CancelToken.source();
  
  const fields = queryParams.fields || "id";
  const expand = queryParams.expand;
  const ordering = queryParams.ordering || "first_name";
  const limit = queryParams.limit || process.env.REACT_APP_DEFAULT_LIMIT_PAGINATION; 
  const offset = queryParams.offset || 0; 

  var url = `${tools.getBaseHost()}/universities/${tools.getUserData().university}/profiles/`;

  const request = axios.get(url, {
    headers: { 
      Authorization: `Bearer ${tools.getUserData().token}`,
      Timezone: tools.getTimezone()
    },
    params: {
      fields,
      expand,
      ordering,
      limit,
      offset,
      'profile': 'teacher',      
      'exclude_course': courseId,
      ...filters,
    },
    cancelToken: cancelToken.token 
  });

  request.catch(error => {
    tools.checkResponseStatus(error);
  });
  return request;
}

export default {
  listProfiles,
  createUser,
  updateUser,
  deleteUser,
  listStudentsFromCourseId,
  listStudentsExcludingCourseId,
  listTeachersFromCourseId,
  listTeachersExcludingCourseId
}